export default {
  // Common elements
  "loading": "Loading...",
  "error": "Error",
  "success": "Success",
  "close": "Close",
  "save": "Save",
  "cancel": "Cancel",
  "continue": "Continue",
  "back": "Back",
  "next": "Next"
};
